"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EAutreCgpGroupsTrads = void 0;
exports.EAutreCgpGroupsTrads = {
    appreciationClient: "Votre appréciation sur le client",
    appreciationOperation: "Votre appréciation sur l'opération",
    modeEntreeRelation: "Mode d'entrée en relation",
    commentConnuConsultim: "Comment avez-vous connu Consultim Asset Management ?",
    dateEntreeRelation: "Date d'entrée en relation",
    coherenceSituationPatrimonialeEtInvestissement: "Coherence entre la situation patrimoniale et l'investissement",
};
